{
  "$id": "http://softball.app/schemas/account",
  "title": "Account",
  "description": "Account info that can be sent to the frontend/browser/client",
  "type": "object",
  "required": ["optimizers"],
  "properties": {
    "optimizers": {
      "type": "array",
      "description": "A list of optimizer ids that the account has selected"
    }
  }
}